import React, { useContext } from "react";
import { ThemeContext } from "@fluentui/react-theme-provider";
import * as S from "@/screen/Map/Components/ContractMapPlanStatusCardStyles";

export interface ContractMapPlanStatusCardProps
{
    title: string;
    statusLabel: string;
    statusColor: string;
}

export const ContractMapPlanStatusCard: React.FC<ContractMapPlanStatusCardProps> = (props) =>
{
    const { title, statusLabel, statusColor } = props;
    const theme = useContext(ThemeContext);

    return(
        <S.StatusCardRoot theme={theme}>
            <S.StatusCardTitle>{title}</S.StatusCardTitle>
            <S.StatusCardBody>
                <S.StatusPill $statusColor={statusColor}>
                    <S.StatusPillText $statusColor={statusColor}>{statusLabel}</S.StatusPillText>
                </S.StatusPill>
            </S.StatusCardBody>
        </S.StatusCardRoot>
    );
};